import axios from 'axios';
import { apiClient } from './api';

// Model Studio APIs
export const createTrainingJob = async (serviceName, metricName, ensembleMethod = 'lscp', epochs = 50, trainingDataPoints = 200) => {
  const response = await apiClient.post('/model-studio/training-jobs', null, {
    params: {
      service_name: serviceName,
      metric_name: metricName,
      ensemble_method: ensembleMethod,
      epochs,
      training_data_points: trainingDataPoints,
    },
  });
  return response.data;
};

export const getTrainingJobs = async () => {
  const response = await apiClient.get('/model-studio/training-jobs');
  return response.data;
};

export const getTrainingJob = async (jobId) => {
  const response = await apiClient.get(`/model-studio/training-jobs/${jobId}`);
  return response.data;
};

export const getAllModels = async () => {
  const response = await apiClient.get('/model-studio/models');
  return response.data;
};

export const getModelVersions = async (modelId) => {
  const response = await apiClient.get(`/model-studio/models/${modelId}`);
  return response.data;
};

export const deployModel = async (versionId, pipelineName) => {
  const response = await apiClient.post('/model-studio/deploy', null, {
    params: { version_id: versionId, pipeline_name: pipelineName },
  });
  return response.data;
};

export const getPipelines = async () => {
  const response = await apiClient.get('/model-studio/pipelines');
  return response.data;
};

export const updatePipelineStatus = async (pipelineId, isActive) => {
  const response = await apiClient.put(`/model-studio/pipelines/${pipelineId}/status`, null, {
    params: { is_active: isActive },
  });
  return response.data;
};

// Remediation APIs
export const getRemediationActions = async () => {
  const response = await apiClient.get('/remediation/actions');
  return response.data;
};

export const createRemediationAction = async (action) => {
  const response = await apiClient.post('/remediation/actions', action);
  return response.data;
};

export const getRemediationRules = async () => {
  const response = await apiClient.get('/remediation/rules');
  return response.data;
};

export const createRemediationRule = async (rule) => {
  const response = await apiClient.post('/remediation/rules', rule);
  return response.data;
};

export const updateRuleStatus = async (ruleId, isActive) => {
  const response = await apiClient.put(`/remediation/rules/${ruleId}/status`, null, {
    params: { is_active: isActive },
  });
  return response.data;
};

export const getRemediationExecutions = async () => {
  const response = await apiClient.get('/remediation/executions');
  return response.data;
};

export const executeRemediation = async (anomalyId) => {
  const response = await apiClient.post('/remediation/execute', null, {
    params: { anomaly_id: anomalyId },
  });
  return response.data;
};
